import { useSeoHead } from '@/seo/useSeoHead';
import { useSeoJsonLd } from '@/seo/useSeoJsonLd';

// Renders nothing visible; wires route-aware SEO head tags and JSON-LD.
export default function SeoManager() {
  useSeoHead();
  useSeoJsonLd();
  return null;
}